// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3D3WS","itemTitle":"ClientEmergencyInfo_itemTitle__2YQrn","itemText":"ClientEmergencyInfo_itemText__25erT"};